import {Calendar} from '@fullcalendar/core';
import dayGridplugin from '@fullcalendar/daygrid';
import timeGridplugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

const calendarOptions = {
    plugins: [
        dayGridplugin,
        timeGridplugin,
        listPlugin,
        interactionPlugin,
        googleCalendarPlugin
    ],
    locale: 'en',
    timeZone: 'America/Los_Angeles',
    defaultView: 'dayGridMonth',
    header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,list'
    },
    selectable: true,
    /*buttonText: {
        today: '오늘',
        month: '월간',
        week: '주간',
        day: '일간',
        list: '목록'
    },*/
    slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: 'short'
    },
    googleCalendarApiKey: 'AIzaSyCiw_WINWtG53EMJfUtv8j3xtPeR2goN5g',
    events: {
        googleCalendarId: 'hopekorean2016@gmail.com',
        className: 'gcal-event' // an option!
    },
    dateClick(info) {
        // console.log(info);
    },
    eventRender(info) {
        info.el.dataset.title = info.event.title;
        info.el.dataset.toggle = 'tooltip';
        $(info.el).tooltip();
    },
    eventClick(info) {
        event.preventDefault();
        const coordinates = {
            x: info.jsEvent.pageX,
            y: info.jsEvent.pageY
        };

        const {title} = info.event;
        const {description} = info.event.extendedProps;


        const detailBox = document.getElementById('calendar-detail').content.cloneNode(true);
        detailBox.querySelector('.title').textContent = title;
        detailBox.querySelector('.description').textContent = description;

        const box = detailBox.querySelector('.calendar-detail');
        if (screen.width > 480){
            box.style.left = `${coordinates.x}px`;
            box.style.top = `${coordinates.y}px`;
        } else {
            box.style.left = '0';
            box.style.bottom = 'calc(50vh - 100px)';
        }

        const closeBtn = detailBox.querySelector('a.close');
        closeBtn.addEventListener('click', () => {
            box.remove();
        });

        document.body.appendChild(detailBox);
        feather.replace();
    }
};

if ( screen.width < 480 ) {
    calendarOptions.contentHeight = 400;
}

window.getEvents = async (start = null, end = null) => {
    try {
        const paramArgs = {
            start: start || moment()
                .format('YYYY-MM-01'),
            end: end || moment()
                .endOf('month')
                .format()
        };

        const res = await axios.get('/api/calendar/get', {
            params: paramArgs
        });

        return res.data;

    } catch (err) {
        console.log(err.response ?? err);
        return null;
    }
};

document.addEventListener('DOMContentLoaded', async function () {
    try {
        const calendarEl = document.getElementById('calendar');
        const calendar = new Calendar(calendarEl, calendarOptions);
        const events = await getEvents;
        calendar.addEventSource(events);
        calendar.render();

    } catch (err) {
        console.log(err);
        showAlert('오류', '일정 정보 로딩 오류', 3);
    }
});

if ( document.getElementById('nav-tab-2') ) {
    $('#nav-tab-2').on('shown.bs.tab', function (e) {
        document.querySelector('.fc-button-active').click();
    });
}
